import { render, staticRenderFns } from "./score.vue?vue&type=template&id=575e5679&"
import script from "./score.vue?vue&type=script&lang=js&"
export * from "./score.vue?vue&type=script&lang=js&"
import style0 from "./score.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports